import * as stylex from '@stylexjs/stylex';
import { MdHowToReg, MdVerifiedUser, MdPsychology } from 'react-icons/md';
import { UserAvatar } from '~components/UserAvatar';
import { shared } from '~styles';
import { styles } from './styles';
import type { PublicMember } from '~pages/Group/query';
const MAX_INTERESTS = 5;
export function Members({
  members,
  count
}: {
  members: PublicMember[];
  count: number;
}) {
  return <section>
      <div {...stylex.props(styles.header)}>
        <MdHowToReg size={22} {...stylex.props(styles.headerIcon)} />
        <span {...stylex.props(styles.headerTitle)}>Members</span>
        <span {...stylex.props(shared.muted)}>· {count}</span>
      </div>
      {members.length === 1 && <p {...stylex.props(styles.searching)}>Searching for tribe members…</p>}
      <ul {...stylex.props(styles.list)}>
        {members.map(m => <MemberCard key={m.id} member={m} />)}
      </ul>
    </section>;
}
function MemberCard({
  member
}: {
  member: PublicMember;
}) {
  if (!member.user) {
    return <li {...stylex.props(styles.card)}>
        <UserAvatar hidden size={88} />
        <div {...stylex.props(styles.info)}>
          <span {...stylex.props(styles.nameRow)}>
            {member.isVerified && <MdVerifiedUser size={16} {...stylex.props(styles.verified)} />}
            <span {...stylex.props(styles.name, shared.muted)}>Hidden member</span>
          </span>
        </div>
      </li>;
  }
  const u = member.user;
  const name = u.fullName ?? u.username;
  return <li {...stylex.props(styles.card)}>
      <UserAvatar name={name} avatarUrl={u.avatarUrl} size={88} />
      <div {...stylex.props(styles.info)}>
        <span {...stylex.props(styles.nameRow)}>
          {u.isVerified && <MdVerifiedUser size={16} {...stylex.props(styles.verified)} />}
          <span {...stylex.props(styles.name)}>
            {name}{u.age != null ? `, ${u.age}` : ''}
          </span>
        </span>
        {(u.personalityCode || u.interests.length > 0) && <div {...stylex.props(styles.chips)}>
            {u.personalityCode && <span {...stylex.props(styles.chip, styles.personalityChip)}>
                <MdPsychology size={14} {...stylex.props(styles.personalityIcon)} />
                {u.personalityCode}
              </span>}
            {u.interests.slice(0, MAX_INTERESTS).map(interest => <span key={interest.id} {...stylex.props(styles.chip, styles.interestChip)}>
                {interest.name}
              </span>)}
            {u.interests.length > MAX_INTERESTS && <span {...stylex.props(styles.chip, styles.interestChip)}>
                +{u.interests.length - MAX_INTERESTS}
              </span>}
          </div>}
      </div>
    </li>;
}